import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Form, Row } from 'react-bootstrap';

import styles from './RequestBreedingConfig.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import Card from '../../Shared/Card/Card';
import { general } from '../../../general';

function RequestBreedingConfig(props: RequestBreedingConfigProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [columns, setColumns] = React.useState<any | undefined>();

    function mapStatusToBoolean(status: string) {
        switch (status) {
            case "enabled":
                return true;
            case "disabled":
                return false;
            default:
                return false;
        }
    }

    function mapBooleanToStatus(status: boolean) {
        return status ? "enabled" : "disabled";
    }

    // Display column name with a checkbox to enable/disable
    function drawColumnEditor(column: any) {
        return (
            <div className={styles.column}>
                <Form.Check 
                    className={styles.switch + " " + (mapStatusToBoolean(column.STATUS) ? styles.switchenabled : styles.switchdisabled)}
                    type="switch"
                    id={column.ID}
                    label={t("requestbreedingconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER)}
                    checked={mapStatusToBoolean(column.STATUS)}
                    onChange={() => {
                        setColumnStatus(column, !mapStatusToBoolean(column.STATUS));
                    }}
                />
            </div>
        );
    }

    function setColumnStatus(column: any, status: boolean) {
        axios.single({
            method: 'put',
            url: "/api/dogs/puppylistings/columns/" + column.ID + "/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                STATUS: mapBooleanToStatus(status)
            }
        }).then((res: any) => {
            getColumns();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getColumns() {
        axios.single({
            method: 'get',
            url: "/api/dogs/puppylistings/columns/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setColumns(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }
            
    useEffect(() => {
        if (
            (
                auth.user?.userdata?.ROLE != "admin" &&
                auth.user?.userdata?.ROLE != "sysadmin" &&
                auth.user?.userdata?.ROLE != "user"
            ) ||
            general.getBreedAccess(auth.user, auth.selectedBreed) == "dogowner"
        ) {
            navigate("/");
        }
    }, [auth.user?.userdata?.ROLE, auth.selectedBreed]);

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getColumns();
        }
    }, [auth.selectedBreed]);

    return (
        <div className="maincontent">
            <div className={styles.requestbreedingconfig}>
                <h1>{t("requestbreedingconfig.title")}</h1>
                <hr/>

                <Container className={styles.container}>
                    <Row className={styles.row}>
                        <Col
                            sm="12"
                            md="6"
                            className={styles.col}
                        >
                            <Card
                                title={t("requestbreedingconfig.fields.title")}
                            >
                                <div>
                                    <hr/>
                                    {columns && columns.map((column: any) => {
                                        return drawColumnEditor(column);
                                    })}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

class RequestBreedingConfigProps {
    
}

export default RequestBreedingConfig;